import './sentry-instrument'
// Sentry initialization should be imported first!
import 'flatpickr/dist/themes/light.css'
import './styles/Datepicker.css'
import './styles/global.css'

import React from 'react'
import * as ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import { setDefaultOptions } from 'date-fns'
import { cs } from 'date-fns/locale'
import moment from 'moment'
import '../../../node_modules/moment/dist/locale/cs'
import { App } from './App'
import { AppProvider } from './context/AppContext'
import { AuthProvider } from './context/AuthContext'
import { CommonSignalRProvider } from './context/CommonSignalRProvider'
import { CustomThemeProvider } from './context/CustomThemeContext'
import { PartnerContextProvider } from './context/PartnerContext'

setDefaultOptions({ locale: cs })
moment.locale('cs')

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = ReactDOM.createRoot(container)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      // Další globální nastavení
    },
  },
})

window.addEventListener('error', (event) => {
  if (
    event.message.includes(
      'ResizeObserver loop completed with undelivered notifications',
    )
  ) {
    console.warn('Ignored ResizeObserver loop error')
    event.stopImmediatePropagation()
    event.preventDefault()
  }
})

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PartnerContextProvider>
        <CustomThemeProvider>
          <AppProvider app={null}>
            <AuthProvider>
              <CommonSignalRProvider>
                <App />
              </CommonSignalRProvider>
            </AuthProvider>
          </AppProvider>
        </CustomThemeProvider>
      </PartnerContextProvider>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  </React.StrictMode>,
)
